var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitment7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137,
    height: 83,
    viewBox: "0 0 137 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172481",
    "data-name": "\\uADF8\\uB8F9 172481",
    transform: "translate(-91 -3528)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_153070",
    "data-name": "\\uC0AC\\uAC01\\uD615 153070",
    width: 27,
    height: 27,
    transform: "translate(91 3528)",
    fill: "#4e95e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153071",
    "data-name": "\\uC0AC\\uAC01\\uD615 153071",
    transform: "translate(118 3555)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153072",
    "data-name": "\\uC0AC\\uAC01\\uD615 153072",
    transform: "translate(145 3528)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153074",
    "data-name": "\\uC0AC\\uAC01\\uD615 153074",
    transform: "translate(118 3582)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153073",
    "data-name": "\\uC0AC\\uAC01\\uD615 153073",
    transform: "translate(145 3555)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153075",
    "data-name": "\\uC0AC\\uAC01\\uD615 153075",
    transform: "translate(172 3528)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153076",
    "data-name": "\\uC0AC\\uAC01\\uD615 153076",
    transform: "translate(145 3582)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153077",
    "data-name": "\\uC0AC\\uAC01\\uD615 153077",
    transform: "translate(172 3555)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153078",
    "data-name": "\\uC0AC\\uAC01\\uD615 153078",
    transform: "translate(199 3528)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment7);
export default __webpack_public_path__ + "static/media/recruitment7.1b5ef19633439ea03b6f3d5533a9b487.svg";
export { ForwardRef as ReactComponent };